import type { Tree } from "./types";

export function wasVisited(tree: Tree): boolean {
  return tree.photos.some((photo) => photo.credit.kind === "team");
}

export function hasUncertainLocation(tree: Tree): boolean {
  return tree.location.precision !== "exact" || tree.verification?.kind === "coords" || tree.verification?.kind === "unknown";
}

export type LocatedTree = Tree & { location: Tree["location"] & { lat: number; lon: number } };

export function hasCoordinates(tree: Tree): tree is LocatedTree {
  return tree.location.precision !== "unknown" && typeof tree.location.lat === "number" && Number.isFinite(tree.location.lat) && typeof tree.location.lon === "number" && Number.isFinite(tree.location.lon);
}
